import SinglePhaseIcon from "./single_phase";

export default function ThreePhaseIcon({ ...props }) {
  return (
    <svg viewBox="0 0 22 22" {...props}>
      <SinglePhaseIcon width={22} height={6} y={16} />
      <SinglePhaseIcon width={22} height={6} />
      <SinglePhaseIcon width={22} height={6} y={8} />
    </svg>
  );
}
